{
  "aiGeneratedAnswer": "KI-generierte Antwort",
  "allCategories": "Alle Kategorien",
  "appliedFiltersToCurrentSearch": "Angewandte Filter auf die aktuelle Suche",
  "apply": "Anwenden",
  "applyFilters": "Filter anwenden",
  "autocompleteOptionsFound_one": "{{count}}{{label}} Autovervollständigungsoption gefunden.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} Autovervollständigungsoptionen gefunden.",
  "autocompleteSuggestion": "autovervollständigung Vorschlag: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} Autovervollständigungsvorschlag gefunden.",
  "autocompleteSuggestionsFound_other": "{{count}} Autovervollständigungsvorschläge gefunden.",
  "basedOnYourDevice": " (basierend auf Ihrem Gerät)",
  "basedOnYourInternetAddress": " (basierend auf Ihrer IP-Adresse)",
  "categoriesText_one": "Die folgende Kategorie lieferte Ergebnisse für - <strong>{{query}}</strong>",
  "categoriesText_other": "Die folgenden Kategorien lieferten Ergebnisse für - <strong>{{query}}</strong>",
  "clearAll": "Alle klar",
  "clearMinAndMax": "Min und Max löschen",
  "clearTheRangeToSelectOptions": "Löschen Sie den Bereich, um Optionen auszuwählen.",
  "clearTheSearchBar": "Löschen Sie die Suchleiste",
  "conductASearch": "Eine Suche durchführen",
  "currentLocation": "Aktueller Standort",
  "didYouMean": "Meinten Sie <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Wenn Autovervollständigungsergebnisse verfügbar sind, mit Pfeiltasten navigieren und mit Enter auswählen.",
  "feedback": "Rückmeldung",
  "filterGroupSearchInputLabel": "Optionen für {{title}} durchsuchen",
  "invalidRange": "Ungültiger Bereich",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Navigieren Sie zur nächsten Ergebnisseite",
  "navigateToThePreviousResultsPage": "Navigieren Sie zur vorherigen Ergebnisseite",
  "noAutocompleteOptionsFound": "0 autovervollständigung Optionen gefunden.",
  "noAutocompleteSuggestionsFound": "0 autovervollständigung Vorschläge gefunden.",
  "noResultsFoundIn": "Keine Ergebnisse in {{currentVerticalLabel}} gefunden.",
  "paginationPage": "Seite {{pageNumber}}",
  "pagination": "Seitennavigation",
  "readMoreAbout": "Mehr erfahren über <a>{{name}}</a>",
  "recentSearch": "neuere Suche: {{query}}",
  "recentSearchesFound_one": "{{count}} letzter Suchbegriff gefunden.",
  "recentSearchesFound_other": "{{count}} letzte Suchbegriffe gefunden.",
  "removeFilter": "Filter „{{displayName}}“ entfernen",
  "resultPreview": "Ergebnisvorschau: {{value}}",
  "resultPreviewsFound_one": "{{count}} Ergebnisvorschau gefunden.",
  "resultPreviewsFound_other": "{{count}} Ergebnisvorschauen gefunden.",
  "resultsCountText_one": "{{count}} Ergebnis",
  "resultsCountText_other": "{{count}} Ergebnisse",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} von {{resultsCount}} Ergebnissen",
  "searchHere": "Suche hier…",
  "showingAllInstead": "Zeige stattdessen alle {{currentVerticalLabel}} an.",
  "showLess": "Weniger anzeigen",
  "showMore": "Mehr anzeigen",
  "sources_one": "Quelle",
  "sources_other": "Quellen ({{count}})",
  "submitSearch": "Suche einreichen",
  "suggestionResultsCount_one": "{{label}} - {{count}} Ergebnis",
  "suggestionResultsCount_other": "{{label}} - {{count}} Ergebnisse",
  "thankYouForYourFeedback": "Vielen Dank für Ihr Feedback!",
  "thisAnsweredMyQuestion": "Das hat meine Frage beantwortet",
  "thisDidNotAnswerMyQuestion": "Das hat meine Frage nicht beantwortet",
  "unselectAnOptionToEnterInARange": "Wählen Sie eine Option ab, um einen Bereich einzugeben.",
  "updateYourLocation": "Aktualisieren Sie Ihren Standort",
  "useCurrentLocation": "Aktuellen Standort verwenden",
  "useMyLocation": "Meinen Standort verwenden",
  "viewAll": "Alle anzeigen",
  "viewDetails": "Details anzeigen"
}
